<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    <div
      v-for="product in otherPics"
      :key="product.id"
      class="product-card bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl cursor-pointer"
      @click="productItemClick(product)"
    >
      <!-- 产品图片 -->
      <div class="h-60 overflow-hidden relative">
        <img
          :src="product.picPath"
          :alt="product.category"
          class="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
        />
      </div>

      <!-- 产品信息 -->
      <div class="p-6">
        <p class="text-gray-600 text-sm mb-4 line-clamp-2">
          {{ product.subCategory || product.category }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDescription',
  components: {},
  props: ['productListPics', 'showPic'],
  data() {
    return {
      otherPics: []
    }
  },
  watch: {
    showPic: {
      handler(newPic) {
        if (newPic && newPic.length > 0) {
          this.formatOtherPic(newPic[0])
        }
      },
      immediate: true
    },
    productListPics: {
      handler(newPics) {
        if (newPics) {
          this.loadProductTags(newPics)
        }
      },
      immediate: true
    }
  },
  methods: {
    productItemClick(item) {
      this.$emit('list-click', item)
    },
    formatOtherPic(pic) {
      // console.log('-----------' + JSON.stringify(pic.picPath))
      // console.log('-----------' + JSON.stringify(this.productListPics))
      let arr = []
      for (let i = 0; i < this.productListPics.length; i++) {
        // console.log(this.productListPics[i].picPath)
        if (this.productListPics[i].picPath !== pic.picPath) {
          arr.push(this.productListPics[i])
        }
      }
      this.otherPics = arr
    },
    loadProductTags(pics) {
      if (pics) {
      }
    }
  },
  mounted() {},
  beforeDestroy() {
    // 清理监听
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/products/ProductDescription.vue